export default __webpack_public_path__ + "static/media/chooseImg.49060821.jpg";